/** @format */

import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import {Trans} from 'react-i18next';

import {Container, Header, IconWrapper, Title, Description, CloseButton} from './styles';

interface Props {
  onClose: () => void;
}

const SuccessState = ({onClose}: Props) => {
  return (
    <Container>
      <Header>
        <IconWrapper>
          <CheckCircleOutlinedIcon />
        </IconWrapper>
        <Title>
          <Trans>Заявка принята</Trans>
        </Title>
      </Header>
      <Description>
        <Trans>Мы получили заявку и свяжемся с вами в кратчайшие сроки</Trans>
      </Description>
      <CloseButton onClick={onClose}>
        <Trans>Закрыть</Trans>
      </CloseButton>
    </Container>
  );
};

export {SuccessState};
